var exports = {
  "x6": "ToggleButton.module__button___THRLc1",
  "vu": "ToggleButton.module__active___THRLc1",
  "AD": "ToggleButton.module__inactive___THRLc1",
};

module.exports = exports;
